import React from "react";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import {
  FaTwitter,
  FaLinkedinIn,
  FaGithub,
  FaWhatsapp,
  FaDatabase,
  FaLayerGroup,
  FaCalculator,
} from "react-icons/fa";
import { SiPowerbi } from "react-icons/si";
import { motion } from "framer-motion";

const LeftBanner = () => {
  const [text] = useTypewriter({
    words: [
      "Power BI Developer.",
      "Data Analyst.",
      "BI Developer.",
      "Fabric Analytics Engineer.",
    ],
    loop: true,
    typeSpeed: 20,
    deleteSpeed: 10,
    delaySpeed: 2000,
  });

  // ONLY icon animation
  const iconHover = {
    scale: 1.15,
    rotate: 6,
    transition: { type: "spring", stiffness: 300 },
  };

  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20">
      {/* Intro */}
      <div className="flex flex-col gap-5">
        <h4 className="text-lg font-normal">WELCOME TO MY PORTFOLIO</h4>

        <h1 className="text-6xl font-bold text-white">
          Hi, I'm{" "}
          <span className="text-designColor capitalize">
            Akshay Kalamkar
          </span>
        </h1>

        <h2 className="text-4xl font-bold text-white">
          a <span>{text}</span>
          <Cursor
            cursorBlinking={false}
            cursorStyle="|"
            cursorColor="#ff014f"
          />
        </h2>

        <p className="text-base font-bodyFont leading-6 tracking-wide">
          I turn complex data into clear, actionable insights by combining analytics with easy-to-understand visuals, 
          helping organizations make smarter decisions.
        </p>
      </div>

      {/* Social + Skills */}
      <div className="flex flex-col xl:flex-row justify-between gap-10">
        {/* Social */}
        <div>
          <h2 className="text-base uppercase font-titleFont mb-4 text-gray-400 tracking-wider">
            Find me in
          </h2>

          <div className="flex gap-5">
            {[
              {
                icon: <FaLinkedinIn />,
                link: "https://www.linkedin.com/in/thebideveloper/",
                name: "LinkedIn",
              },
              {
                icon: <FaWhatsapp />,
                link: "https://wa.me/918237234351",
                name: "WhatsApp",
              },
              {
                icon: <FaGithub />,
                link: "https://github.com/TheBIDeveloper",
                name: "GitHub",
              },
              {
                icon: <FaTwitter />,
                link: "https://x.com/__TheDeveloper_",
                name: "Twitter",
              },
            ].map((social, idx) => (
              <a
                key={idx}
                href={social.link}
                target="_blank"
                rel="noreferrer"
                className="relative group w-12 h-12 bg-gray-900 rounded-full flex justify-center items-center text-gray-300 shadow-lg hover:text-designColor hover:shadow-[0_0_15px_rgba(255,0,79,0.6)] transition-colors duration-300"
              >
                {/* ICON (animated) */}
                <motion.span whileHover={iconHover}>
                  {social.icon}
                </motion.span>

                {/* TOOLTIP (below icon) */}
                <span
                  className="
                    absolute
                    top-full
                    mt-2
                    hidden
                    group-hover:block
                    px-2 py-1
                    text-xs
                    rounded
                    bg-black
                    text-white
                    whitespace-nowrap
                  "
                >
                  {social.name}
                </span>
              </a>
            ))}
          </div>
        </div>

        {/* Skills */}
        <div>
          <h2 className="text-base uppercase font-titleFont mb-4 text-gray-400 tracking-wider">
            BEST SKILLS
          </h2>

          <div className="flex gap-5">
            {[
              { icon: <SiPowerbi />, title: "Power BI" },
              { icon: <FaDatabase />, title: "SQL" },
              { icon: <FaLayerGroup />, title: "Microsoft Fabric" },
              { icon: <FaCalculator />, title: "DAX" },
            ].map((skill, idx) => (
              <div
                key={idx}
                className="relative group w-12 h-12 bg-gray-900 rounded-full flex justify-center items-center text-gray-300 shadow-md hover:shadow-[0_0_20px_rgba(0,255,255,0.5)] transition-shadow duration-300"
              >
                {/* ICON (animated) */}
                <motion.span whileHover={iconHover}>
                  {skill.icon}
                </motion.span>

                {/* TOOLTIP (below icon) */}
                <span
                  className="
                    absolute
                    top-full
                    mt-2
                    hidden
                    group-hover:block
                    px-2 py-1
                    text-xs
                    rounded
                    bg-black
                    text-white
                    whitespace-nowrap
                  "
                >
                  {skill.title}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeftBanner;
